// @ts-strict-ignore
import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const dropzoneContainer = css`
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const readyContainer = css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
`;

export const successBlock = css`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  @media (min-width: ${dimensions.tablet}) {
    margin-top: 0;
  }
`;

export const successText = (theme: Theme) => css`
  color: ${theme.success.textBase};
`;

export const zoneText = (theme: Theme) => css`
  padding: 1rem 1.5rem;
  border: 1px dashed ${theme.system.borderBase};
  border-radius: ${borders.radiusBase};
  outline: none;
  width: 100%;
  background-color: ${theme.system.backgroundMuted};
`;

export const dropzoneIsDroppable = (theme: Theme) => css`
  border-color: ${theme.system.borderActive};
`;

export const fileWrapper = css`
  margin-bottom: 1rem;
`;

export const fileThumbnail = filePath => css`
  width: 40px;
  height: 40px;
  background-image: url("${filePath}");
  background-size: cover;
  background-position: center;
  border-radius: ${borders.radiusBase};
`;
